import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import FormPreview from './Components/CommonComponents/FormPreview';
import FormPreview from "../CommonComponents/FormPreview";
import axios from "axios";
import api from "../../api/axiosInstance";
const FormViews = () => {debugger;
  const { id } = useParams(); // Extract form ID from URL
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

const recordGuidStr = id;
const userData = JSON.parse(localStorage.getItem('user')); // Get user info from localStorage
const loggedinUserid = userData ? userData.email : null; // Get logged-in user email
  
  useEffect(() => {
            debugger;
   // Use axios to fetch the data
   api
   .get(`/Form/PreviewForm`, {
          params: {
            recordGuidStr,
            loggedinUserid
          }
  
  }) // Replace with your actual API URL
   .then((response) => {debugger;
     setFormData(response.data);
     setLoading(false);
   })
   .catch((err) => {
     setError(err.message || "Something went wrong");
     setLoading(false);
   });
  }, [recordGuidStr,loggedinUserid]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
          
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Form Preview</h1>
      <FormPreview formData={formData} />
    </div>
  );
};

export default FormViews;
